import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const INPUT_ID = "home-search-q";

interface HomeSearchFormProps {
  soundCountLabel: string;
}

/**
 * The homepage's search field (PRODUCT.md, "the quiet panel keeps its search
 * bar"). A plain GET form to the library: it works before hydration and
 * without JS, fetches nothing from the homepage, and hands the query to
 * /sounds, which reads `?q=` itself and reports `library_search` once its
 * results settle.
 */
export default function HomeSearchForm({ soundCountLabel }: HomeSearchFormProps) {
  return (
    <form role="search" action="/sounds" method="get" className="m-0">
      <label htmlFor={INPUT_ID} className="block text-sm font-semibold text-[var(--tls-fg-strong)]">
        Search all {soundCountLabel} sounds
      </label>
      <div className="mt-2 flex max-w-xl items-center gap-3">
        <Input
          id={INPUT_ID}
          type="search"
          name="q"
          placeholder="Vine boom, Mario"
          autoComplete="off"
          enterKeyHint="search"
          className="flex-1"
        />
        <Button type="submit" data-cuelume-release="scan">
          Search
        </Button>
      </div>
    </form>
  );
}
